import PropTypes from 'prop-types';
import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import MultiFilterSelect from './MultiFilterSelect';
import { jsx as _jsx } from "react/jsx-runtime";
function ProductAreaSelect(props) {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  const productAreaOptions = useSelector(({
    zorseTicketInspector
  }) => zorseTicketInspector.filterOptions.productAreas.toArray());

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  const productAreas = useSelector(({
    zorseTicketInspector
  }) => zorseTicketInspector.filters.productAreas.toArray());
  const options = useMemo(() => productAreaOptions.map(productArea => ({
    text: productArea.name,
    value: productArea.id
  })).sort((a, b) => a.text.localeCompare(b.text)), [productAreaOptions]);
  return /*#__PURE__*/_jsx(MultiFilterSelect, {
    "data-test-id": "filter-select",
    defaultValue: productAreas,
    labelLangPath: "app.filter.panel.productArea.label",
    onSelect: props.onSelect,
    options: options,
    placeholderLangPath: "app.filter.panel.productArea.placeholder"
  });
}
ProductAreaSelect.propTypes = {
  onSelect: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(ProductAreaSelect);